import appApi from "@/api/appApi";

// let index = 1;

export default {
  async getBrackets(id) {
    /* index = 1;
    const brackets = {
      1: getMatches(),
      2: getMatches(2),
      4: getMatches(4),
      8: getMatches(8)
    };

    console.log(brackets);

    return {
      success: true,
      data: brackets
    }; */

    const { data } = await appApi.get(`/tournament/grid?id=${id}`);

    return data;
  },

  async getFinalTeams() {
    const response = await fetch("/uploads/brackets-final-teams.json");
    const data = await response.json();

    return data;
  },

  async getFinalBracketsData() {
    const response = await fetch("/uploads/brackets-final.json");
    const data = await response.json();

    return data;
  }
};

/* function getMatch() {
  const match = {
    id: index
  };
  index++;
  return match;
}

function getMatches(amount = 1) {
  const matches = [];
  for (let i = 0; i < amount; i++) {
    matches.push(getMatch());
  }
  return matches;
} */
